import { render, staticRenderFns } from "./MedicalInstitutionAdd.vue?vue&type=template&id=03df8076"
import script from "./MedicalInstitutionAdd.vue?vue&type=script&lang=js"
export * from "./MedicalInstitutionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports